import {hrmsWithPath} from '../../services/http/api/rest';

const rest = hrmsWithPath('/v1/wishes')

const wish = {
    listById: (eventId: string) => rest.get('/{{eventId}}', {eventId}, {}),
    create: (eventId: string, data: any) => rest.post('/{{eventId}}', {eventId}, data, {}),
    update: (wishId: string, data: any) => rest.put('/{{wishId}}', {wishId}, data, {}),
    delete: (wishId: string) => rest.del('/{{wishId}}', {wishId}, {}, {}),
    mail: (id: string, data: string) => rest.post('/{{id}}/mail', {id}, data, {}, {"Content-Type": "text/plain"}),
}

export default wish;